export default __webpack_public_path__ + "static/media/skippedmeal@3x.4d91c597.jpg";